import React from 'react';

interface SidebarProps {
  currentSection: string;
  onNavigate: (section: string) => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ currentSection, onNavigate }) => {
  const sections = [
    { id: 'dashboard', label: 'Dashboard', icon: 'ti-chart-line' },
    { id: 'products', label: 'Produtos', icon: 'ti-home' },
    { id: 'templates', label: 'Templates', icon: 'ti-file-text' },
    { id: 'database', label: 'Base de Dados', icon: 'ti-database' },
    { id: 'messages', label: 'Fila de Mensagens', icon: 'ti-mail' },
    { id: 'tasks', label: 'Task Board', icon: 'ti-layout-columns' },
    { id: 'whatsapp', label: 'WhatsApp', icon: 'ti-brand-whatsapp' },
  ];

  return (
    <aside className="col-md-3 col-lg-2 sidebar">
      <div className="logo">
        <img src="/assets/images/LOGO_HOLLOS.png" alt="Hollos Logo" className="logo-image" />
      </div>
      <nav className="nav-menu">
        {sections.map((section) => (
          <a
            key={section.id}
            href="#"
            className={`nav-item ${currentSection === section.id ? 'active' : ''}`}
            data-section={section.id}
            onClick={(e) => {
              e.preventDefault();
              onNavigate(section.id);
            }}
          >
            <i className={`ti ${section.icon}`} aria-hidden="true"></i>
            <span>{section.label}</span>
          </a>
        ))}
      </nav>
    </aside>
  );
};